import * as Annotations from './index.js';

export const EXPANDABLE = Object.values(Annotations).filter(a => a.expandable).map(a => a.schemaType);